var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$vuetify.breakpoint.smAndUp)?_c('section',[(_vm.documentTabs.length > 0)?_c('v-flex',{staticClass:"grid-container",attrs:{"grow":""}},[_c('div',{staticClass:"grid-image"},[_c(_vm.$vuetify.breakpoint.mdAndUp ? 'h2' : 'h3',{tag:"component"},[_vm._v(_vm._s(_vm.$t(_vm.title)))]),_c('v-tabs',{attrs:{"light":"","slider-color":"brand","color":"brand","show-arrows":""},model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},_vm._l((_vm.documentTabs),function(tab){return _c('v-tab',{key:tab,staticClass:"cursor-pointer",attrs:{"ripple":""}},[_c('div',[_vm._v(_vm._s(tab))])])}),1)],1),_vm._l((_vm.onlyPopulatedFields(_vm.onlyPopulatedSections)),function(field,i){return [(
          field.type.toLowerCase() !== 'file' &&
            field.type.toLowerCase() !== 'linksto'
        )?_c('div',{key:i + ' -tab',staticClass:"supply-chain-content"},[_c('h3',[_vm._v("\n          "+_vm._s(_vm.findTranslationMultipleOptions(
              field.name,
              _vm.documentDefaultLang,
              _vm.defaultLanguage
            ))+"\n        ")]),(
            !['map', 'date', 'url', 'multi-select'].includes(
              field.type.toLowerCase()
            )
          )?_c('p',{staticClass:"primary--text mt-1 text-and-area",domProps:{"innerHTML":_vm._s(
            _vm.findTranslationMultipleOptions(
              field.value,
              _vm.documentDefaultLang,
              _vm.defaultLanguage
            )
          )}}):(field.type.toLowerCase() === 'multi-select')?_c('div',[_c('div',{staticClass:"mb-2"},[_c('span',[_vm._v(_vm._s(_vm.findTranslationMultipleOptions(
                field.value,
                _vm.documentDefaultLang,
                _vm.defaultLanguage
              ).text))])]),_vm._l((_vm.findTranslationMultipleOptions(
              field.value,
              _vm.documentDefaultLang,
              _vm.defaultLanguage
            ).items),function(item){return _c('v-checkbox',{key:item.label,staticClass:"multi-select-check",attrs:{"dense":"","hide-details":"","value":"","label":item.label,"disabled":""},model:{value:(item.value),callback:function ($$v) {_vm.$set(item, "value", $$v)},expression:"item.value"}})})],2):(field.type.toLowerCase() === 'url')?_c('base-U-R-L-Field',{attrs:{"value":_vm.findTranslationMultipleOptions(
              field.value,
              _vm.documentDefaultLang,
              _vm.defaultLanguage
            ),"editMode":false}}):(field.type.toLowerCase() === 'date')?_c('p',{staticClass:"primary--text mt-1"},[_vm._v("\n          "+_vm._s(_vm.momentDate(
              _vm.findTranslationMultipleOptions(
                field.value,
                _vm.documentDefaultLang,
                _vm.defaultLanguage
              )
            ))+"\n        ")]):_c('new-base-map',{staticClass:"mt-1 mb-4",attrs:{"location":_vm.findTranslationMultipleOptions(
              field.value,
              _vm.documentDefaultLang,
              _vm.defaultLanguage
            ),"height":'350px',"zoom":14}})],1):(field.type.toLowerCase() === 'linksto')?_c('div',{key:`${_vm.documentKey}
          ${_vm.findTranslationMultipleOptions(
            field.name,
            _vm.documentDefaultLang,
            _vm.defaultLanguage
          )}`,staticClass:"pa-0 supply-chain-content"},[(
            _vm.findTranslationMultipleOptions(
              field.value,
              _vm.documentDefaultLang,
              _vm.defaultLanguage
            ).filter(i => i.available).length > 0
          )?_c('h3',[_vm._v("\n          "+_vm._s(_vm.findTranslationMultipleOptions(
              field.name,
              _vm.documentDefaultLang,
              _vm.defaultLanguage
            ))+"\n        ")]):_vm._e(),(
            _vm.findTranslationMultipleOptions(
              field.value,
              _vm.documentDefaultLang,
              _vm.defaultLanguage
            ).filter(i => i.available).length > 0
          )?_c('v-list',[_vm._l((_vm.findTranslationMultipleOptions(
              field.value,
              _vm.documentDefaultLang,
              _vm.defaultLanguage
            )),function(item,itemIndex){return [(item.available)?_c('v-list-item',{key:`${item.id}-i-${itemIndex}`,staticClass:"pa-0 cursor-pointer",class:[item.type !== 'CUSTOM' ? 'cursor-pointer' : ''],on:{"click":function($event){return _vm.redirectToLink(item)}}},[_c('v-avatar',{staticClass:"mr-1",attrs:{"width":item.type !== 'PROFILE' ? '80px' : '30px',"height":"30px","left":"","tile":""}},[_c('base-image',{attrs:{"type":"u","image-type":"t","file-name":item.logo,"profile-id":_vm.getProfileId(item),"contain":false,"imageAlt":`${_vm.$t('linked')} ${item.type.toLowerCase()} ${_vm.$t(
                      'inShowcase'
                    )} ${_vm.document.name}`}})],1),_c('v-list-item-content',[_c('v-list-item-title',[_c('h6',{staticClass:"primary--text"},[_vm._v("\n                    "+_vm._s(item.name)+"\n                  ")])]),_c('v-list-item-subtitle',[_c('v-chip',{attrs:{"color":"brand","outlined":"","label":"","x-small":""}},[_vm._v(_vm._s(item.type === 'DOCUMENT'
                      ? _vm.$t('showcase')
                      : _vm.sentenceCase(_vm.setI18nSyntax(item.type))))])],1)],1)],1):_vm._e()]})],2):_vm._e()],1):_c('v-layout',{key:`${_vm.documentKey} ${_vm.findTranslationMultipleOptions(
            field.name,
            _vm.documentDefaultLang,
            _vm.defaultLanguage
          )}-${i}`,staticClass:"grid-image",attrs:{"column":"","justify-center":"","align-center":""}},[(field.type.toLowerCase() !== 'file')?_c('div',{key:`${_vm.documentKey}
            ${_vm.findTranslationMultipleOptions(
              field.name,
              _vm.documentDefaultLang,
              _vm.defaultLanguage
            )}`,staticClass:"supply-chain-content"},[_c('h3',[_vm._v("\n            "+_vm._s(_vm.findTranslationMultipleOptions(
                field.name,
                _vm.documentDefaultLang,
                _vm.defaultLanguage
              ))+"\n          ")]),_c('p',{staticClass:"primary--text mt-1",domProps:{"innerHTML":_vm._s(
              _vm.findTranslationMultipleOptions(
                field.value,
                _vm.documentDefaultLang,
                _vm.defaultLanguage
              )
            )}})]):_vm._e(),(
            field.accepts &&
              field.accepts[0].toLowerCase() === 'image' &&
              field.value.names &&
              field.value.names.length > 0 &&
              field.value.names[0] !== ''
          )?_c('base-multiple-images',{key:_vm.documentKey,staticStyle:{"border-radius":"3px","width":"100%"},attrs:{"type":"u","image-type":"o","profile-id":_vm.profileInfo.profile.profileId.replace('#', ''),"editMode":false,"file-names":field.value.names,"aspectRatio":1.618,"file-text":field.text
              ? _vm.findTranslationMultipleOptions(
                  field.text,
                  _vm.documentDefaultLang,
                  _vm.defaultLanguage
                )
              : '',"width":"100%","imageAlt":`${_vm.$t('imagesForShowcase')} ${
              _vm.document.name
            } ${_vm.findTranslationMultipleOptions(
              field.name,
              _vm.documentDefaultLang,
              _vm.defaultLanguage
            )}`}}):(
            field.accepts &&
              field.accepts[0].toLowerCase() === 'video' &&
              field.value.names &&
              field.value.names.length > 0 &&
              field.value.names[0] !== ''
          )?_c('base-video-player',{key:_vm.documentKey,staticClass:"mb-4",attrs:{"type":"u","video-type":"o","profile-id":_vm.profileInfo.profile.profileId.replace('#', ''),"file-name":field.value.names[0],"width":"100%","videoKey":`video-key-${_vm.documentKey}`}}):(
            field.accepts &&
              field.accepts[0].toLowerCase() === 'audio' &&
              field.value.names &&
              field.value.names.length > 0 &&
              field.value.names[0] !== ''
          )?_c('base-sound-player',{key:_vm.documentKey,attrs:{"type":"u","sound-type":"o","profile-id":_vm.profileInfo.profile.profileId.replace('#', ''),"file-name":field.value.names[0],"artist":_vm.profileInfo.profile.name,"width":"100%"}}):(
            field.accepts &&
              field.accepts[0].toLowerCase() === 'pdf' &&
              field.value.names &&
              field.value.names.length > 0 &&
              field.value.names[0] !== ''
          )?_c('base-download',{key:_vm.documentKey,attrs:{"type":"u","download-type":"o","profile-id":_vm.profileInfo.profile.profileId.replace('#', ''),"file-name":field.value.names[0],"show":true,"width":"100%"}}):_vm._e(),(
            field.accepts &&
              field.accepts[0].toLowerCase() === 'video_link' &&
              field.value.names &&
              field.value.names.length > 0 &&
              field.value.names[0] !== ''
          )?_c('base-video-link',{key:_vm.documentKey,attrs:{"height":"315px","value":field.value.names[0]}}):_vm._e()],1)]})],2):_vm._e()],1):_c('section',[(_vm.documentTabs.length > 0)?[_c('h4',[_vm._v(_vm._s(_vm.$t(_vm.title)))]),_vm._l((_vm.documentTabs),function(tab,index){return _c('div',{key:tab},[_c('div',{staticClass:"d-flex justify-space-between",class:[_vm.active === index ? 'xs-tab-active' : 'xs-tab'],on:{"click":function($event){return _vm.hanldeActiveSection(index)}}},[_c('span',{class:[_vm.active === index ? 'brand--text' : 'primary--text'],staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(tab))]),_c('v-icon',{attrs:{"color":_vm.active === index ? 'brand' : 'primary'}},[_vm._v(_vm._s(_vm.active === index ? _vm.icons.mdiChevronUp : _vm.icons.mdiChevronDown))])],1),_c('v-expand-transition',[(_vm.active === index)?_c('div',{staticClass:"my-4"},[_vm._l((_vm.onlyPopulatedFields(_vm.onlyPopulatedSections)),function(field,i){return [(
                field.type.toLowerCase() !== 'file' &&
                  field.type.toLowerCase() !== 'linksto'
              )?_c('div',{key:i + ' -tab',staticClass:"supply-chain-content"},[_c('h3',[_vm._v("\n                "+_vm._s(_vm.findTranslationMultipleOptions(
                    field.name,
                    _vm.documentDefaultLang,
                    _vm.defaultLanguage
                  ))+"\n              ")]),(
                  !['map', 'date', 'url', 'multi-select'].includes(
                    field.type.toLowerCase()
                  )
                )?_c('p',{staticClass:"primary--text mt-1 text-and-area",domProps:{"innerHTML":_vm._s(
                  _vm.findTranslationMultipleOptions(
                    field.value,
                    _vm.documentDefaultLang,
                    _vm.defaultLanguage
                  )
                )}}):(field.type.toLowerCase() === 'multi-select')?_c('div',[_c('div',{staticClass:"mb-2"},[_c('span',[_vm._v(_vm._s(_vm.findTranslationMultipleOptions(
                      field.value,
                      _vm.documentDefaultLang,
                      _vm.defaultLanguage
                    ).text))])]),_vm._l((_vm.findTranslationMultipleOptions(
                    field.value,
                    _vm.documentDefaultLang,
                    _vm.defaultLanguage
                  ).items),function(item){return _c('v-checkbox',{key:item.label,staticClass:"multi-select-check",attrs:{"dense":"","hide-details":"","value":"","label":item.label,"disabled":""},model:{value:(item.value),callback:function ($$v) {_vm.$set(item, "value", $$v)},expression:"item.value"}})})],2):(field.type.toLowerCase() === 'date')?_c('p',{staticClass:"primary--text mt-1"},[_vm._v("\n                "+_vm._s(_vm.momentDate(
                    _vm.findTranslationMultipleOptions(
                      field.value,
                      _vm.documentDefaultLang,
                      _vm.defaultLanguage
                    )
                  ))+"\n              ")]):(field.type.toLowerCase() === 'url')?_c('base-U-R-L-Field',{attrs:{"value":_vm.findTranslationMultipleOptions(
                    field.value,
                    _vm.documentDefaultLang,
                    _vm.defaultLanguage
                  ),"editMode":false}}):_c('new-base-map',{staticClass:"mt-1 mb-4",attrs:{"location":_vm.findTranslationMultipleOptions(
                    field.value,
                    _vm.documentDefaultLang,
                    _vm.defaultLanguage
                  ),"height":'350px',"zoom":14}})],1):(field.type.toLowerCase() === 'linksto')?_c('div',{key:_vm.findTranslationMultipleOptions(
                  field.name,
                  _vm.documentDefaultLang,
                  _vm.defaultLanguage
                ),staticClass:"pa-0 supply-chain-content"},[(
                  _vm.findTranslationMultipleOptions(
                    field.value,
                    _vm.documentDefaultLang,
                    _vm.defaultLanguage
                  ).filter(i => i.available).length > 0
                )?_c('h3',[_vm._v("\n                "+_vm._s(_vm.findTranslationMultipleOptions(
                    field.name,
                    _vm.documentDefaultLang,
                    _vm.defaultLanguage
                  ))+"\n              ")]):_vm._e(),(
                  _vm.findTranslationMultipleOptions(
                    field.value,
                    _vm.documentDefaultLang,
                    _vm.defaultLanguage
                  ).filter(i => i.available).length > 0
                )?_c('v-list',[_vm._l((_vm.findTranslationMultipleOptions(
                    field.value,
                    _vm.documentDefaultLang,
                    _vm.defaultLanguage
                  )),function(item,itemIndex){return [(item.available)?_c('v-list-item',{key:`${item.id}-i-${itemIndex}`,staticClass:"pa-0 cursor-pointer",class:[item.type !== 'CUSTOM' ? 'cursor-pointer' : ''],on:{"click":function($event){return _vm.redirectToLink(item)}}},[_c('v-avatar',{staticClass:"mr-1",attrs:{"width":item.type !== 'PROFILE' ? '80px' : '30px',"height":"30px","left":"","tile":""}},[_c('base-image',{attrs:{"type":"u","image-type":"t","file-name":item.logo,"profile-id":_vm.getProfileId(item),"contain":false,"imageAlt":`${_vm.$t('linked')} ${item.type.toLowerCase()} ${_vm.$t(
                            'inShowcase'
                          )} ${_vm.document.name}`}})],1),_c('v-list-item-content',[_c('v-list-item-title',[_c('h6',{staticClass:"primary--text"},[_vm._v("\n                          "+_vm._s(item.name)+"\n                        ")])]),_c('v-list-item-subtitle',[_c('v-chip',{attrs:{"color":"brand","outlined":"","label":"","x-small":""}},[_vm._v(_vm._s(item.type === 'DOCUMENT'
                            ? _vm.$t('showcase')
                            : _vm.sentenceCase(_vm.setI18nSyntax(item.type))))])],1)],1)],1):_vm._e()]})],2):_vm._e()],1):_c('v-row',{key:`${_vm.documentKey}${_vm.findTranslationMultipleOptions(
                  field.name,
                  _vm.documentDefaultLang,
                  _vm.defaultLanguage
                )}-${i}`,staticClass:"ma-0",attrs:{"justify":"center","align":"center"}},[(field.type.toLowerCase() !== 'file')?_c('div',{key:`${_vm.documentKey}
                  ${_vm.findTranslationMultipleOptions(
                    field.name,
                    _vm.documentDefaultLang,
                    _vm.defaultLanguage
                  )}`,staticClass:"supply-chain-content"},[_c('h3',[_vm._v("\n                  "+_vm._s(_vm.findTranslationMultipleOptions(
                      field.name,
                      _vm.documentDefaultLang,
                      _vm.defaultLanguage
                    ))+"\n                ")]),_c('p',{staticClass:"primary--text mt-1",domProps:{"innerHTML":_vm._s(
                    _vm.findTranslationMultipleOptions(
                      field.value,
                      _vm.documentDefaultLang,
                      _vm.defaultLanguage
                    )
                  )}})]):_vm._e(),(
                  field.accepts &&
                    field.accepts[0].toLowerCase() === 'image' &&
                    field.value.names &&
                    field.value.names.length > 0 &&
                    field.value.names[0] !== ''
                )?_c('base-multiple-images',{key:_vm.documentKey,staticClass:"mb-4",staticStyle:{"border-radius":"3px","width":"100%"},attrs:{"type":"u","image-type":"o","profile-id":_vm.profileInfo.profile.profileId.replace('#', ''),"editMode":false,"file-names":field.value.names,"aspectRatio":1.618,"file-text":field.text
                    ? _vm.findTranslationMultipleOptions(
                        field.text,
                        _vm.documentDefaultLang,
                        _vm.defaultLanguage
                      )
                    : '',"width":"100%","imageAlt":`${_vm.$t('imagesForShowcase')} ${
                    _vm.document.name
                  } ${_vm.findTranslationMultipleOptions(
                    field.name,
                    _vm.documentDefaultLang,
                    _vm.defaultLanguage
                  )}`}}):(
                  field.accepts &&
                    field.accepts[0].toLowerCase() === 'video' &&
                    field.value.names &&
                    field.value.names.length > 0 &&
                    field.value.names[0] !== ''
                )?_c('base-video-player',{key:_vm.documentKey,staticClass:"mb-4",attrs:{"type":"u","video-type":"o","profile-id":_vm.profileInfo.profile.profileId.replace('#', ''),"file-name":field.value.names[0],"width":"100%","videoKey":`video-key-${_vm.documentKey}`}}):(
                  field.accepts &&
                    field.accepts[0].toLowerCase() === 'audio' &&
                    field.value.names &&
                    field.value.names.length > 0 &&
                    field.value.names[0] !== ''
                )?_c('base-sound-player',{key:_vm.documentKey,staticClass:"mb-4",attrs:{"type":"u","sound-type":"o","profile-id":_vm.profileInfo.profile.profileId.replace('#', ''),"file-name":field.value.names[0],"artist":_vm.profileInfo.profile.name,"width":"100%"}}):(
                  field.accepts &&
                    field.accepts[0].toLowerCase() === 'pdf' &&
                    field.value.names &&
                    field.value.names.length > 0 &&
                    field.value.names[0] !== ''
                )?_c('base-download',{key:_vm.documentKey,staticClass:"mb-4",attrs:{"type":"u","download-type":"o","profile-id":_vm.profileInfo.profile.profileId.replace('#', ''),"file-name":field.value.names[0],"show":true,"width":"100%"}}):_vm._e(),(
                  field.accepts &&
                    field.accepts[0].toLowerCase() === 'video_link' &&
                    field.value.names &&
                    field.value.names.length > 0 &&
                    field.value.names[0] !== ''
                )?_c('base-video-link',{key:_vm.documentKey,staticClass:"mb-4",attrs:{"height":"315px","value":field.value.names[0]}}):_vm._e()],1)]})],2):_vm._e()])],1)})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }